var map = {
	"./aida.png": 362,
	"./allfunds-connect.png": 363,
	"./bankit.png": 364,
	"./bnp-neolink.png": 365,
	"./cityvelocity.png": 366,
	"./credem.png": 367,
	"./eif-efront.png": 368,
	"./euribor-eu.png": 369,
	"./fdg-mcc.png": 370,
	"./fdg-sace.png": 371,
	"./feeonly-8a+.png": 372,
	"./feeonly.png": 373,
	"./google-calendar.png": 374,
	"./google-chat.png": 375,
	"./google-docs.png": 376,
	"./google-drive.png": 377,
	"./google-forms.png": 378,
	"./google-keep.png": 379,
	"./google-mail.png": 380,
	"./google-meet.png": 381,
	"./google-sheets.png": 382,
	"./google-slides.png": 383,
	"./infocamere.png": 384,
	"./matrix_ms.png": 385,
	"./normattiva.png": 386,
	"./pec-aruba.png": 387,
	"./podessys.png": 388,
	"./sgss.png": 389,
	"./six-telekurs.png": 390,
	"./statpro-revolution.png": 391,
	"./tmf-group.png": 392,
	"./whatsapp.png": 393,
	"./wolters-kluwer.png": 394
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 361;